import React, { useState } from 'react';
import { Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import ResetPasswordForm from '../../components/CreatePasswordForm';
import CardScene from '../../components/CardScene';
import ErrorReset from '../ErrorReset';
import { Transitions } from '../../services/Transition';

const useStyles = (isSM) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '40px',
    paddingBottom: '40px',
    backgroundColor: isSM && 'white',
  },
  text: {
    maxWidth: '400px',
    textAlign: 'center',
    color: 'secondary.dark',
  },
});

const CreatePassword = () => {
  const { t } = useTranslation();
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles(isSM);
  const [catchedError, setCatchedError] = useState('NONE');

  function errorInfo(value) {
    if (value) {
      setCatchedError(value);
    } else {
      setCatchedError('NONE');
    }
  }

  function contentSelector() {
    if (catchedError === 'NONE') {
      return <ResetPasswordForm errorType={errorInfo} />;
    }
    if (catchedError === Transitions.Types.EXPIRED_CODE) {
      return <ErrorReset errorType={Transitions.Types.EXPIRED_CODE} />;
    }
    if (catchedError === Transitions.Types.FAIL_CODE) {
      return <ErrorReset errorType={Transitions.Types.FAIL_CODE} />;
    }
    return <></>;
  }

  function headerSelector() {
    if (catchedError === 'NONE') {
      return (
        <Typography variant="h2" color="textSecondary" sx={classes.text}>
          {t('CREATE_NEW_PASSWORD')}
        </Typography>
      );
    }
    if (
      catchedError === Transitions.Types.EXPIRED_CODE ||
      catchedError === Transitions.Types.FAIL_CODE
    ) {
      return (
        <Typography variant="h2" color="textSecondary" sx={classes.text}>
          {t('OOPS')}
        </Typography>
      );
    }
    return <></>;
  }

  const RenderFormWindow = () => {
    return (
      <>
        <Helmet>
          <title>{t('PASSWORD_RESET_HEADER_TITLE')}</title>
        </Helmet>
        <CardScene header={headerSelector()}>
          <div style={classes.container}>{contentSelector()}</div>
        </CardScene>
      </>
    );
  };

  return (
    <>
      <RenderFormWindow />
    </>
  );
};

export default CreatePassword;
